import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '@src/hooks/useAuth';
import Layout from '@src/components/Layout';
import CinematicLoader from '@src/components/CinematicLoader';
import DashboardPage from '@src/pages/DashboardPage';
import ResumesPage from '@src/pages/ResumesPage';
import JobsPage from '@src/pages/JobsPage';
import ApplicationsPage from '@src/pages/ApplicationsPage';
import SettingsPage from '@src/pages/SettingsPage';
import LoginPage from '@src/pages/LoginPage';
import RegisterPage from '@src/pages/RegisterPage';
import TailorPage from '@src/pages/TailorPage';

const App = () => {
  const auth = useAuth();

  if (auth.loading) {
    return <CinematicLoader message="Loading" submessage="Preparing your dashboard" />;
  }

  if (!auth.user) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage onLogin={auth.login} />} />
        <Route path="/register" element={<RegisterPage onLogin={auth.login} />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Layout user={auth.user} onLogout={auth.logout}>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/resumes" element={<ResumesPage />} />
        <Route path="/jobs" element={<JobsPage />} />
        <Route path="/applications" element={<ApplicationsPage />} />
        <Route path="/tailor" element={<TailorPage />} />
        <Route path="/settings" element={<SettingsPage user={auth.user} onUpdate={auth.refresh} />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
};

export default App;
